document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-menu-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
      const nav = document.querySelector('[data-mobile-nav]');
      if (nav) nav.classList.toggle('is-open');
    });
  });

  document.querySelectorAll('[data-product-form]').forEach(form => {
    const select = form.querySelector('[name="id"]');
    const price = document.querySelector('[data-product-price]');
    if (!select) return;
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      const button = form.querySelector('[type="submit"]');
      if (button) {
        button.disabled = option.dataset.available !== 'true';
        button.textContent = option.dataset.available === 'true' ? 'Add to cart' : 'Sold out';
      }
    });
  });
});
document.addEventListener('DOMContentLoaded', () => {
  const gallery = document.querySelector('[data-product-gallery]');

  if (!gallery) return;

  const slides = Array.from(
    gallery.querySelectorAll('[data-gallery-slide]')
  );

  const previousButton = document.querySelector(
    '[data-gallery-previous]'
  );

  const nextButton = document.querySelector(
    '[data-gallery-next]'
  );

  const currentCounter = document.querySelector(
    '[data-gallery-current]'
  );

  if (slides.length < 2) return;

  const getCurrentSlide = () => {
    const galleryLeft = gallery.scrollLeft;
    const slideWidth = gallery.clientWidth;

    if (!slideWidth) return 0;

    return Math.round(galleryLeft / slideWidth);
  };

  const updateCounter = () => {
    const currentSlide = Math.min(
      Math.max(getCurrentSlide(), 0),
      slides.length - 1
    );

    if (currentCounter) {
      currentCounter.textContent = String(currentSlide + 1);
    }

    if (previousButton) {
      previousButton.disabled = currentSlide === 0;
    }

    if (nextButton) {
      nextButton.disabled = currentSlide === slides.length - 1;
    }
  };

  const scrollToSlide = (index) => {
    const safeIndex = Math.min(
      Math.max(index, 0),
      slides.length - 1
    );

    gallery.scrollTo({
      left: safeIndex * gallery.clientWidth,
      behavior: 'smooth'
    });
  };

  previousButton?.addEventListener('click', () => {
    scrollToSlide(getCurrentSlide() - 1);
  });

  nextButton?.addEventListener('click', () => {
    scrollToSlide(getCurrentSlide() + 1);
  });

  let scrollTimer;

  gallery.addEventListener('scroll', () => {
    window.clearTimeout(scrollTimer);

    scrollTimer = window.setTimeout(updateCounter, 80);
  });

  window.addEventListener('resize', updateCounter);

  updateCounter();
});
document.addEventListener('DOMContentLoaded', () => {
  const recommendationSection = document.querySelector(
    '[data-product-recommendations]'
  );

  if (!recommendationSection) return;

  const productId = recommendationSection.dataset.productId;
  const sectionId = recommendationSection.dataset.sectionId;
  const limit = recommendationSection.dataset.limit || 4;
  const recommendationUrl = recommendationSection.dataset.url;

  if (!productId || !sectionId || !recommendationUrl) return;

  const url =
    `${recommendationUrl}` +
    `?section_id=${encodeURIComponent(sectionId)}` +
    `&product_id=${encodeURIComponent(productId)}` +
    `&limit=${encodeURIComponent(limit)}` +
    `&intent=related`;

  fetch(url)
    .then((response) => {
      if (!response.ok) {
        throw new Error('Unable to load product recommendations.');
      }

      return response.text();
    })
    .then((html) => {
      const temporaryContainer = document.createElement('div');
      temporaryContainer.innerHTML = html;

      const loadedSection = temporaryContainer.querySelector(
        '[data-product-recommendations]'
      );

      if (!loadedSection) return;

      const recommendationsContent = loadedSection.innerHTML.trim();

      if (!recommendationsContent) {
        recommendationSection.remove();
        return;
      }

      recommendationSection.innerHTML = loadedSection.innerHTML;

      initializeRecommendationSlider(recommendationSection);
    })
    .catch((error) => {
      console.error(error);
      recommendationSection.remove();
    });

  function initializeRecommendationSlider(section) {
    const slider = section.querySelector(
      '[data-recommendations-slider]'
    );

    if (!slider) return;

    const slides = Array.from(
      slider.querySelectorAll('.kv-recommendations__slide')
    );

    const previousButton = section.querySelector(
      '[data-recommendations-previous]'
    );

    const nextButton = section.querySelector(
      '[data-recommendations-next]'
    );

    const currentCounter = section.querySelector(
      '[data-recommendations-current]'
    );

    if (slides.length < 2) return;

    const getSlideWidth = () => {
      const firstSlide = slides[0];

      if (!firstSlide) return slider.clientWidth;

      return firstSlide.getBoundingClientRect().width + 14;
    };

    const getCurrentSlide = () => {
      const slideWidth = getSlideWidth();

      if (!slideWidth) return 0;

      return Math.round(slider.scrollLeft / slideWidth);
    };

    const updateControls = () => {
      const currentSlide = Math.min(
        Math.max(getCurrentSlide(), 0),
        slides.length - 1
      );

      if (currentCounter) {
        currentCounter.textContent = String(currentSlide + 1);
      }

      if (previousButton) {
        previousButton.disabled = currentSlide === 0;
      }

      if (nextButton) {
        nextButton.disabled =
          currentSlide >= slides.length - 1;
      }
    };

    const scrollToSlide = (index) => {
      const safeIndex = Math.min(
        Math.max(index, 0),
        slides.length - 1
      );

      slider.scrollTo({
        left: safeIndex * getSlideWidth(),
        behavior: 'smooth'
      });
    };

    previousButton?.addEventListener('click', () => {
      scrollToSlide(getCurrentSlide() - 1);
    });

    nextButton?.addEventListener('click', () => {
      scrollToSlide(getCurrentSlide() + 1);
    });

    let scrollTimer;

    slider.addEventListener('scroll', () => {
      window.clearTimeout(scrollTimer);

      scrollTimer = window.setTimeout(
        updateControls,
        80
      );
    });

    window.addEventListener('resize', updateControls);

    updateControls();
  }
});